import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  FilterList as FilterIcon,
  FilterListOff as FilterOffIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";

const Filters = ({ filtri, allRows, setRows }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [filtersActive, setFiltersActive] = useState(isDesktop);
  const [fonteDisabled, setFonteDisabled] = useState(true);

  const initialFiltersState = {
    nome: "",
    tipologia: filtri.tipologie.value,
    tipo: filtri.tipo.value,
    fonte: filtri.fonte.value,
  };

  const [filters, setFilters] = useState(initialFiltersState);
  const [searched, setSearched] = useState(false);

  const switchFilterActive = () => {
    setFiltersActive((prev) => !prev);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tipo") {
      if (Number(value) === 2) {
        setFonteDisabled(false);
        setFilters((prev) => ({
          ...prev,
          [name]: value,
          fonte: filtri.fonte.value, // reset fonte to default when enabling
        }));
      } else {
        setFonteDisabled(true);
        setFilters((prev) => ({
          ...prev,
          [name]: value,
          fonte: filtri.fonte.value, // reset fonte to default when disabling
        }));
      }
    } else if (name === "fonte") {
      setFilters((prev) => ({
        ...prev,
        fonte: value,
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  console.log(filters);

  const handleSubmit = (e) => {
    e.preventDefault();

    const filtered = allRows.filter((row) => {
      // Nome: partial, case-insensitive match
      const matchNome = row.nome
        .toLowerCase()
        .includes(filters.nome.toLowerCase());

      // Tipologia: exact match with row.idTipologia
      const matchTipologia = row.idAccordoTipologia === filters.tipologia;

      // Tipo
      const matchTipo =
        Number(filters.tipo) === 0
          ? row.idtipo === 1 || row.idtipo === 2
          : row.idtipo === Number(filters.tipo);

      // Fonte
      const matchFonte =
        !fonteDisabled && Number(filters.fonte) === 0
          ? row.idfonte === 1 || row.idfonte === 2 || row.idfonte === 3
          : row.idfonte === Number(filters.fonte);

      if (fonteDisabled) {
        return matchNome && matchTipologia && matchTipo;
      } else {
        return matchNome && matchTipologia && matchTipo && matchFonte;
      }
    });

    console.log(filtered);

    setRows(filtered);
    setSearched(true); // <-- Enable Reset after search
  };

  const handleReset = () => {
    setRows(allRows);
    setFilters(initialFiltersState);
    setSearched(false); // <-- Disable Reset after reset
  };

  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            padding: "8px 16px",
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
              alignItems: "start",
              padding: "1rem",
            },
          }}
        >
          {!filtersActive ? (
            <Stack
              direction="row"
              sx={{
                cursor: "pointer",
                userSelect: "none",
                padding: "15px 0",
                [theme.breakpoints.down("md")]: {
                  padding: "0",
                },
              }}
              onClick={switchFilterActive}
            >
              <FilterIcon
                sx={{
                  marginRight: "16px",
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "4px",
                  },
                }}
              />
              <Typography variant="h4" mr={4}>
                Filtra
              </Typography>
            </Stack>
          ) : (
            <Stack
              direction="row"
              sx={{
                cursor: "pointer",
                userSelect: "none",
                padding: "15px 0",
                [theme.breakpoints.down("md")]: {
                  padding: "0",
                },
              }}
              onClick={switchFilterActive}
            >
              <FilterOffIcon
                sx={{
                  marginRight: "16px",
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "4px",
                  },
                }}
              />
            </Stack>
          )}
          {filtersActive && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "center",
                [theme.breakpoints.down("sm")]: {
                  flexDirection: "column",
                  flexWrap: "nowrap",
                  alignItems: "end",
                  width: "100%",
                },
              }}
            >
              <TextField
                size="small"
                label="Nome"
                name="nome"
                id="nome"
                onChange={handleChange}
                value={filters.nome}
                sx={{
                  width: "200px",
                  margin: "8px",
                  minWidth: "200px",
                  [theme.breakpoints.down(1500)]: {
                    width: "120px",
                  },
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "0",
                    margin: "8px 0",
                    width: "100%",
                  },
                }}
              />
              <FormControl
                size="small"
                fullWidth
                margin="none"
                sx={{
                  width: "200px",
                  margin: "8px",
                  minWidth: "200px",
                  [theme.breakpoints.down(1500)]: {
                    width: "120px",
                  },
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "0",
                    margin: "8px 0",
                    width: "100%",
                  },
                }}
              >
                <InputLabel id="tipologia-label">Tipologia</InputLabel>
                <Select
                  labelId="tipologia-label"
                  id="tipologia"
                  name="tipologia"
                  label="Tipologia"
                  fullWidth
                  onChange={handleChange}
                  value={filters.tipologia}
                >
                  {filtri.tipologie.dataset.map((el) => (
                    <MenuItem key={el.label} value={el.value}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                size="small"
                fullWidth
                margin="none"
                sx={{
                  width: "200px",
                  margin: "8px",
                  minWidth: "200px",
                  [theme.breakpoints.down(1500)]: {
                    width: "120px",
                  },
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "0",
                    margin: "8px 0",
                    width: "100%",
                  },
                }}
              >
                <InputLabel id="tipo-label">Tipo</InputLabel>
                <Select
                  labelId="tipo-label"
                  id="tipo"
                  name="tipo"
                  label="Tipo"
                  fullWidth
                  onChange={handleChange}
                  value={filters.tipo}
                >
                  {filtri.tipo.dataset.map((el) =>
                    el.value === 0 ? (
                      <MenuItem
                        key={el.label}
                        value={el.value}
                        sx={{ height: 30 }}
                      >
                        {el.label}
                      </MenuItem>
                    ) : (
                      <MenuItem key={el.label} value={el.value}>
                        {el.label}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
              <FormControl
                size="small"
                fullWidth
                margin="none"
                sx={{
                  width: "200px",
                  margin: "8px",
                  minWidth: "200px",
                  [theme.breakpoints.down(1500)]: {
                    width: "120px",
                  },
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: "0",
                    margin: "8px 0",
                    width: "100%",
                  },
                }}
              >
                <InputLabel id="fonte-label">Fonte</InputLabel>
                <Select
                  labelId="fonte-label"
                  id="fonte"
                  name="fonte"
                  label="Fonte"
                  fullWidth
                  onChange={handleChange}
                  value={filters.fonte}
                  disabled={fonteDisabled}
                >
                  {filtri.fonte.dataset.map((el) =>
                    el.value === 0 ? (
                      <MenuItem
                        key={el.label}
                        value={el.value}
                        sx={{ height: 30 }}
                      >
                        {el.label}
                      </MenuItem>
                    ) : (
                      <MenuItem key={el.label} value={el.value}>
                        {el.label}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>

              <Button
                variant="contained"
                type="submit"
                sx={{
                  margin: "8px",
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    margin: "4px 0 0 0",
                  },
                }}
              >
                Cerca
              </Button>
              <Button
                disabled={!searched}
                variant="outlined"
                sx={{
                  margin: "8px",
                  [theme.breakpoints.down("md")]: {
                    marginBottom: "8px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    margin: "4px 0 0 0",
                  },
                }}
                onClick={handleReset}
              >
                Reset
              </Button>
            </Box>
          )}
        </Box>
      </form>
    </Card>
  );
};

export default Filters;
